import { marked } from 'marked';
marked.setOptions({
    breaks: true,
    gfm: true
});
const ALLOWED_TAGS = ['p', 'strong', 'em', 'ul', 'ol', 'li', 'code', 'a', 'br'];
const TAG_REGEX = /<\/?([a-zA-Z][a-zA-Z0-9]*)\b[^>]*>/gi;
function sanitize(html, allowedTags) {
    return html.replace(TAG_REGEX, (match, tag) => {
        return allowedTags.includes(tag.toLowerCase()) ? match : '';
    });
}
export function renderMarkdown(content) {
    if (!content)
        return '';
    const html = marked.parse(content, { async: false });
    return sanitize(html, ALLOWED_TAGS);
}
